export enum ActionType {
  Verification,
  TwoFactorAuthentication,
}
